import { useEffect, useState } from 'react';
import {
  DefaultBox,
  GridBox,
  SideBox,
  FloatingBox,
  Height60,
} from '../../etc/LBox/LBox';
import {
  HeadTitle,
  ButtonSelect,
  Tmd16,
  Spacer,
  TextField,
  TextButton,
  Button,
  MenuBottomsheet,
  TheSearchBottomsheet,
  SelectField,
} from 'oui';
import { ClkBtnSubEventNm } from '../../../application/hooks/useBeacon';
import BottomSheetTemp from '../../etc/BottomSheetTemp/BottomSheetTemp';
import { currencyKR } from '../../../application/helper/filter';
import { useMtgConditions } from '../../../application/bloc/useMtgConditions';
import { useMtgSelect } from '../../../application/bloc/useMtgSelect';
import useStep5 from '../../../application/bloc/useStep5';

const Step5 = () => {
  const {
    houseTyp,
    carOwnerYn,
    debtYn,
    debtTyp,
    healthPayer,
    personal,
    isActive,
    onClickHouseTyp,
    onClickCarOwnerYn,
    onClickDebtYn,
    onClickDebtTyp,
    onChangeCarNo,
    onClickHealthPayer,
    submitPersonalInfo,
    warningText,
    isReuse,
    setReuseYn,
  } = useStep5();

  const {
    selectSheet,
    openSelectSheet,
    mortgageInfo,
    onChangeWrappingInput,
    onChangeInput,
  } = useMtgConditions();

  const {
    sendBeaconClkBtnOption,
    sendBeaconClkBtn,
    getLdongList,
    searchApartment,
    searchRateSeq,
  } = useMtgSelect();

  const [isOpenSearch, setOpenSearch] = useState<boolean>(false);
  const [isOpenManualSheet, setIsOpenManualSheet] = useState(false);
  const [areaList, setAreaList] = useState<any[]>([]);

  const onClickSelectField = (type: string) => {
    openSelectSheet(type);
  };

  // 일단 reset 동작 하게 해놓고, 마지막 단계에서 isApartment가 N이면 보내지 않는 식으로 하면 될 듯
  const resetDefaultInfo = () => {
    onChangeInput({ key: 'isRegulation', value: false });
    onChangeInput({ key: 'dong', value: '' });
    onChangeInput({ key: 'ho', value: '' });
    onChangeInput({ key: 'housePrice', value: '' });
    onChangeInput({ key: 'hopefulAmt', value: '' });
    onChangeInput({
      key: 'unkAddress',
      value: 'N',
    });
    onChangeInput({ key: 'credPoint', value: null });
    setAreaList([]);
    onChangeWrappingInput({ key: 'apartment', text: '', value: '' });
    onChangeWrappingInput({ key: 'rateSeq', text: '', value: '' });
    onChangeWrappingInput({ key: 'floor', text: '', value: '' });
    onChangeWrappingInput({ key: 'houseType', text: '', value: '' });
    onChangeWrappingInput({ key: 'ldongCode', text: '', value: '' });
  };

  const loadAreaList = async (apartment: string) => {
    const response = await searchRateSeq(apartment);
    setAreaList(response);
  };

  const onChangeMenuBottomsheet = async (e: any) => {
    if (selectSheet.stateNm === 'isApartment') {
      // 취합하지 않는 정보 고정값으로 넣어주는 부분. 백앤드에서 처리하고 있을 수 있지만 우선 남겨둠 (250403 래영)
      if (e.value === 'Y') {
        onChangeInput({ key: 'salaryAmt', value: personal.salaryAmt });
        onChangeInput({ key: 'credPoint', value: 900 });
        onChangeWrappingInput({ key: 'jobType', text: '직장인', value: '01' });
        onChangeWrappingInput({
          key: 'purposeCd',
          text: '후순위 담보 대출',
          value: '50',
        });
        onChangeWrappingInput({ key: 'haveCnt', text: '1주택', value: '20' });
        onChangeWrappingInput({
          key: 'previousYn',
          text: '대출금이 없어요',
          value: 'N',
        });
        onChangeWrappingInput({
          key: 'tenantYn',
          text: '세입자가 없어요',
          value: 'N',
        });
        onChangeWrappingInput({
          key: 'marriageCd',
          text: '미혼',
          value: '10',
        });
        onChangeWrappingInput({
          key: 'houseType',
          text: '아파트',
          value: '10',
        });
        setOpenSearch(true);
      } else {
        resetDefaultInfo();
      }
    }

    if (e.fullNm && !e.pldongCode) {
      void (await onClickLdongField({
        title: '시/군/구',
        ldongCode: e.value,
        stateNm: 'ldongCode',
      }));
      return;
    }

    if (e.fullNm && e.pldongCode) {
      const isEnd: boolean = await onClickLdongFieldFromDong({
        title: '읍/면/동',
        ldongCode: e.value,
        stateNm: 'ldongCode',
      });
      if (isEnd) {
        const list: any = await searchApartment('', e.value);
        openSelectSheet('', {
          title: `${e.text || '대출 받을'} 아파트`,
          stateNm: 'apartment',
          items: list,
        });
        return;
      }
    }

    // 아파트 선택 시 평수 리스트 저장
    if (selectSheet.stateNm === 'apartment') {
      loadAreaList(e.value);
    }

    // 평수 선택 시 최저 시세 저장 케이스
    if (selectSheet.stateNm === 'rateSeq') {
      onChangeInput({ key: 'housePrice', value: e.amt });
      onChangeWrappingInput({ key: 'floor', text: '3층 이상', value: '30' });
    }

    onChangeWrappingInput({
      key: selectSheet.stateNm,
      text: e.fullNm || e.text,
      value: e.value,
    });

    if (selectSheet.title) {
      sendBeaconClkBtnOption({
        btmsheet_name: selectSheet.title,
        option_name: e.fullNm || e.text,
        before_option_name: mortgageInfo[selectSheet.stateNm]?.text ?? '',
      });
    }
  };

  const onClickLdongField = async (item?: any) => {
    const list = await getLdongList(item.ldongCode);
    openSelectSheet('', {
      title: item.title,
      stateNm: item.stateNm,
      items: list,
    });
  };

  const onClickLdongFieldFromDong = async (item?: any) => {
    const list = await getLdongList(item.ldongCode);
    if (list.length > 0) {
      openSelectSheet('', {
        title: item.title,
        stateNm: item.stateNm,
        items: list,
      });
    }
    return !(list.length > 0);
  };

  const onClickApartmentItem = async (item: any) => {
    if (mortgageInfo.apartment.value == item.value) {
      return;
    }

    resetDefaultInfo();

    if (item.isRegulation) {
      onChangeInput({ key: 'isRegulation', value: item.isRegulation });
    }

    if (item.ldongCode) {
      onChangeWrappingInput({
        key: 'ldongCode',
        text: '',
        value: item.ldongCode,
      });
    }

    onChangeWrappingInput({
      key: 'apartment',
      text: item.name,
      value: item.code,
    });

    sendBeaconClkBtn(ClkBtnSubEventNm.HouseList, {
      btmsheet_name: '주택 주소',
      house_name: item.name,
    });

    if (item.code) {
      const response = await searchRateSeq(item.code);
      setAreaList(() => {
        return response;
      });
    }
  };

  const onClickAreaField = (item: any) => {
    if (!areaList || areaList.length <= 0) {
      if (mortgageInfo?.apartment?.value) {
        // 만약 평수 목록이 없다면 평수 목록을 불러온다.
        loadAreaList(mortgageInfo.apartment.value);
      }
    }

    openSelectSheet('', {
      title: item.title,
      stateNm: item.stateNm,
      items: areaList,
    });
  };

  const onClickManualSelect = () => {
    onChangeInput({ key: 'hopefulAmt', value: '' });
    onChangeInput({ key: 'housePrice', value: '' });
    onChangeWrappingInput({
      key: 'houseType',
      text: '아파트',
      value: '10',
    });
    onChangeWrappingInput({ key: 'floor', text: '3층 이상', value: '30' });
    onChangeWrappingInput({ key: 'apartment', text: '', value: '' });
    onChangeWrappingInput({ key: 'rateSeq', text: '', value: '' });

    selectSheet.onClose();

    setTimeout(() => {
      setIsOpenManualSheet(true);
    }, 500);
  };

  const onClickReuseButton = () => {
    setReuseYn();
  };

  const onClickHouseTypButton = (houseInfo: any) => {
    const { code, codeNm } = houseInfo;

    onClickHouseTyp(code);

    if (codeNm === '자가') {
      onClickSelectField('IA10');
    } else {
      resetDefaultInfo();
      onChangeWrappingInput({
        key: 'isApartment',
        text: '기타 주택을 보유하고 있어요',
        value: 'N',
      });
    }
  };

  const onClickRegister = () => {
    resetDefaultInfo();
    setIsOpenManualSheet(false);
    setOpenSearch(false);
    void onClickLdongField({ title: '주택 시/도', stateNm: 'ldongCode' });
  };

  const validateAmt = (value?: string) => {
    if (!value)
      return {
        validate: true,
        amt: '',
      };

    let amt = value.replace(/,/g, '');
    if (!amt) {
      return {
        validate: true,
        amt: '',
      };
    }

    if (amt.length > 1 && amt.substring(0, 1) === '0') amt = amt.substring(1);
    const num = Number(amt);
    if (isNaN(num))
      return {
        validate: false,
      };
    if (num === 0 && amt.length > 1)
      return {
        validate: false,
      };

    if (amt.length > 6)
      return {
        validate: false,
      };

    return {
      validate: true,
      amt: amt,
    };
  };

  useEffect(() => {
    if (areaList && areaList.length > 0)
      onClickAreaField({ title: '평수 (공급/전용)', stateNm: 'rateSeq' });
  }, [areaList]);

  return (
    <>
      <HeadTitle textTitle={'마지막으로 추가정보를\n 입력해주세요'} />
      <DefaultBox>
        <Tmd16 text={'의료보험 가입 구분'} color={'#696969'} />
        <Spacer size={'xs'} />
        <GridBox>
          {healthPayer.map((item: any) => {
            return (
              <ButtonSelect
                key={item?.codeNm}
                text={item?.codeNm}
                value={personal?.healthPayerTyp ?? ''}
                onChange={() => onClickHealthPayer(item.code)}
                state={
                  personal?.healthPayerTyp === item.code ? 'focused' : 'enabled'
                }
              />
            );
          })}
        </GridBox>
        <Spacer size={'md'} />
        <Tmd16 text={'주택 소유 상태'} color={'#696969'} />
        <Spacer size={'xs'} />
        <GridBox>
          {houseTyp.map((item: any) => {
            return (
              // ButtonSelect 컴포넌트의 input type이 radio여서, OUI 건드리지 않고 여기서 임시 처리 (250331 래영)
              <div
                key={item?.codeNm}
                onClick={(e) => {
                  e.preventDefault();
                  onClickHouseTypButton(item);
                }}
              >
                <ButtonSelect
                  text={item?.codeNm}
                  value={personal?.houseTyp ?? ''}
                  state={
                    personal?.houseTyp === item.code ? 'focused' : 'enabled'
                  }
                />
              </div>
            );
          })}
        </GridBox>
        <Spacer size={'md'} />
        <Tmd16 text={'본인 명의 소유 차량'} color={'#696969'} />
        <Spacer size={'xs'} />
        <GridBox>
          {carOwnerYn.map((item: any) => {
            return (
              <ButtonSelect
                key={item?.codeNm}
                text={item?.codeNm}
                value={personal?.carOwnerYn ?? ''}
                onChange={() => onClickCarOwnerYn(item.code)}
                state={
                  personal?.carOwnerYn === item.code ? 'focused' : 'enabled'
                }
              />
            );
          })}
        </GridBox>

        {personal?.carOwnerYn === 'Y' && (
          <>
            <Spacer size={'xs'} />
            <SideBox topDownAnimation>
              <TextField
                inputTitle="차량 번호"
                state={personal?.carNo ? 'focused' : 'enabled'}
                autoFocus={personal?.carNo === '' && personal?.carOwnerYn}
                value={personal?.carNo ?? ''}
                warning={warningText}
                onChangeTextInput={onChangeCarNo}
                placeholder={'예.123가1234'}
              />
            </SideBox>
          </>
        )}
        <Spacer size={'md'} />
        <Tmd16 text={'개인회생 및 파산 여부'} color={'#696969'} />
        <Spacer size={'xs'} />
        <GridBox>
          {debtYn.map((item: any) => {
            return (
              <ButtonSelect
                key={item?.codeNm}
                text={item?.codeNm}
                value={personal?.debtYn ?? ''}
                onChange={() => onClickDebtYn(item.code)}
                state={personal?.debtYn === item.code ? 'focused' : 'enabled'}
              />
            );
          })}
        </GridBox>

        {personal?.debtYn === 'Y' && (
          <GridBox topDownAnimation>
            {debtTyp.map((item: any) => {
              return (
                <ButtonSelect
                  key={item?.codeNm}
                  text={item?.codeNm}
                  value={personal?.debtTyp ?? ''}
                  onChange={() => onClickDebtTyp(item.code)}
                  state={
                    personal?.debtTyp === item.code ? 'focused' : 'enabled'
                  }
                />
              );
            })}
          </GridBox>
        )}
      </DefaultBox>

      <SideBox>
        <TextButton
          state={isReuse ? 'focused' : 'enabled'}
          size={'md'}
          text={'입력한 정보 다음에도 사용하기'}
          iconLeft={{
            name: 'CheckCircle',
          }}
          iconColor={'primary'}
          onClickButton={onClickReuseButton}
        />
      </SideBox>
      <Spacer size={'xl'} />

      <FloatingBox>
        <Button
          flexible={true}
          configuration={'contained'}
          children={'다음'}
          isDisabled={!isActive}
          state={!isActive ? 'disabled' : 'enabled'}
          onClick={isActive ? submitPersonalInfo : () => {}}
        />
      </FloatingBox>
      <MenuBottomsheet
        selectType="instant"
        isOpenBottomSheet={selectSheet.open}
        title={selectSheet.title}
        subTitle={selectSheet.subTitle}
        items={selectSheet.items}
        onClickMenuItem={(e: any) => {
          selectSheet.onClose();
          void onChangeMenuBottomsheet(e);
        }}
        isMaxHeight={
          selectSheet.stateNm === 'ldongCode' ||
          selectSheet.stateNm === 'apartment' ||
          selectSheet.stateNm === 'rateSeq'
        }
        onClickCloseMenuBottomsheet={selectSheet.onClose}
        defaultValue={mortgageInfo[selectSheet.stateNm]}
        bottomButton={
          selectSheet.stateNm === 'apartment'
            ? {
                desc: '찾으시는 아파트가 없으신가요?',
                buttonText: '주택가격 입력하기',
                onClick: onClickManualSelect,
              }
            : undefined
        }
      />
      <TheSearchBottomsheet
        onSearchCompany={searchApartment}
        isSearchBottomsheetOpen={isOpenSearch}
        title={'주택 주소'}
        value={mortgageInfo.apartment.text as string}
        placeholder={'지역 명 / 아파트 이름'}
        hasClearButton
        showIsLoading
        onClose={() => setOpenSearch(false)}
        onRegistCompany={onClickApartmentItem}
        onClickRegister={onClickRegister}
      />
      <BottomSheetTemp
        isOpen={isOpenManualSheet}
        title="아파트 가격을 입력해 주세요"
        confirmBtn={{
          isActive: mortgageInfo.ldongCode.text && mortgageInfo.hopefulAmt,
          onConfirm: () => setIsOpenManualSheet(false),
        }}
        onClickCloseBottomSheet={() => setIsOpenManualSheet(false)}
      >
        <Height60>
          <SelectField
            value={mortgageInfo.ldongCode.text}
            placeholder={'주택 유형'}
            onChangeSelectField={() => {}}
            onClickSelectField={onClickRegister}
          />
        </Height60>
        <Spacer size={'xs'} />
        <Tmd16 text={'주택 가격'} color={'#696969'} />
        <TextField
          placeholder={'0'}
          state={'enabled'}
          adornment={'만 원'}
          inputMode={'numeric'}
          helperText={currencyKR(mortgageInfo?.hopefulAmt * 10000)}
          value={mortgageInfo.hopefulAmt ?? ''}
          onChangeTextInput={(value) => {
            const { validate, amt } = validateAmt(value);
            if (validate) {
              onChangeInput({ key: 'hopefulAmt', value: amt });
            }
          }}
          hasClearButton
        />
      </BottomSheetTemp>
    </>
  );
};

export default Step5;
